export const phoneInputPatternFactory = (mask: string) => {
  const numberBlocks = mask.replaceAll("-", " ").split(" ");
  const pattern = numberBlocks
    .map((block) => `(\\d{${block.length}})`)
    .join(" ");
  return pattern;
};
